import { defineEvents, SHARED_EVENTS } from '@3plearning/mx-teacher-analytics';

export const ANALYTICS_EVENTS = {
    pageView: 'page.view',
    pageTimeOnPage: 'page.time-on-page',
    ebookDownloaded: 'ebook.downloaded'
};

const appEvents = defineEvents({
    ...SHARED_EVENTS,
    [ANALYTICS_EVENTS.ebookDownloaded]: { group: 'ebook', props: {} }
});

export default appEvents;
